import React, { useCallback, useState } from 'react';

import Accordion from '@mui/material/Accordion';

import AccordionDetails from '@mui/material/AccordionDetails';

import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import Paper from '@mui/material/Paper';

import { AccordionSummaryWrapper, TarifeWrapper, Container } from './tarife.styles';

type PretBarciType = {
  galleryPhoto: string;
  denumireBarca: string;
  capacitate: string;
  putere: string;
  pretMars: string;
  pretStationare: string;
  necesitaPermis: boolean;
  faraSkipper: boolean;
}

const createRow = (
  galleryPhoto: PretBarciType["galleryPhoto"],
  denumireBarca: PretBarciType["denumireBarca"],
  capacitate: PretBarciType["capacitate"],
  putere: PretBarciType["putere"],
  pretMars: PretBarciType["pretMars"],
  pretStationare: PretBarciType["pretStationare"],
  necesitaPermis: PretBarciType["necesitaPermis"],
  faraSkipper: PretBarciType["faraSkipper"],
) => ({ galleryPhoto, denumireBarca, capacitate, putere, pretMars, pretStationare, necesitaPermis, faraSkipper } as unknown as PretBarciType);


const preturiData = {
  family: [
    createRow('/assets/images/tarife/river-500-yellow-thumb.jpg', 'Nautic Club DC One - ❤ River 410 Alb cu Roșu', '4 + 1 sau 400kg', '5cp / 3.72kW', 'De la 150 ron', '50 ron', false, true),
    createRow(`/assets/images/tarife/river-500-yellow-thumb.jpg`, 'Nautic Club DC Two - 💙 River 410 Bleo cu Roșu', '4 + 1 sau 400kg', '5cp / 3.72kW', 'De la 150 ron', '50 ron', false, true),
    createRow(`/assets/images/tarife/river-500-yellow-thumb.jpg`, 'Nautic Club DC Three - 💛 River 410  Galben cu gri', '4 + 1 sau 400kg', '5cp / 3.72kW', 'De la 150 ron', '50 ron', false, true),
    createRow(`/assets/images/tarife/river-500-yellow-thumb.jpg`, 'Nautic Club DC Four -  🍊 River 410  Portocaliu', '4 + 1 sau 400kg', '5cp / 3.72kW', 'De la 150 ron', '50 ron', false, true),
    createRow(`/assets/images/tarife/river-500-yellow-thumb.jpg`, 'Nautic Club DC Five - 🍏 River 410 Măr verde', '4 + 1 sau 400kg', '5cp / 3.72kW', 'De la 150 ron', '50 ron', false, true),
  ],
  entry: [
    createRow('/assets/images/tarife/river-500-yellow-thumb.jpg', 'Nautic Club DC Trainer - River 540 - Roșu intens', '5 + 1 sau 500kg', '25cp / 18.64kW', 'De la 250 ron', '50 ron', true, true),    
    
  ],
  experience: [
    createRow('/assets/images/tarife/river-500-yellow-thumb.jpg', 'LadyBug', '4 + 1 sau 500kg', '60cp / 44.74kW', 'De la 350 ron', '100 ron', true, true),    
    createRow('/assets/images/tarife/river-500-yellow-thumb.jpg', 'Princess Daniela Cristina - Maxum 1900 SR3', '7 + 1 sau 600kg', '100cp / 74.57kW', 'De la 750 ron', '100 ron', true, true),    
  ],
  premium: [
    createRow('/assets/images/tarife/river-500-yellow-thumb.jpg', 'Shark DC - Bayliner Ciera 2655', '7 pers.', '9', 'De la 750 ron', '700 ron / 30m', false, true),    

  ]
};

export const TarifePage = () => {

  // Accordions
  const [expanded, setExpanded] = React.useState<string | false>('panel1');
  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Dialogs
  const [dialogDetailOpenState, setDialogDetailOpenState] = useState(false);
  const handleDetailModalOpenState = useCallback((openState: boolean) => setDialogDetailOpenState(openState), []);

  return (
    <TarifeWrapper>
      <span className='mask bg-gradient-dark opacity-4'></span>
      <Container>
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummaryWrapper
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h5" component="h5" sx={{ display: 'block' }}>
              Ambarcatiuni prietenoase, de familie
            </Typography>

            <Typography variant="body2" component="p">
              Bărci vesele, stabile și colorate - ideale pentru familie, relaxare și poze superbe pe lac!
            </Typography>
          </AccordionSummaryWrapper>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Denumire ambarcatiune</TableCell>
                    <TableCell align="center">Capacitate</TableCell>
                    <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>Putere</TableCell>
                    <TableCell align="center">Preț / hr marș</TableCell>
                    <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>Preț / oră staționare</TableCell>
                    <TableCell align="center">Necesită permis</TableCell>
                    <TableCell align="center">Fara skipper</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {preturiData.family.map((row: PretBarciType) => (
                    <TableRow
                      hover
                      onClick={() => setDialogDetailOpenState(true)}
                      key={row.denumireBarca}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>
                        <img src={row.galleryPhoto} alt={row.denumireBarca} />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.denumireBarca}
                      </TableCell>
                      <TableCell align="center">{row.capacitate}</TableCell>
                      <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>{row.putere}</TableCell>
                      <TableCell align="center">{row.pretMars}</TableCell>
                      <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>{row.pretStationare}</TableCell>
                      <TableCell align="center">{row.necesitaPermis ? '✔ Da' : '❌Nu'}</TableCell>
                      <TableCell align="center">{row.faraSkipper ? '✔ Da' : '❌Nu'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
          <AccordionSummaryWrapper
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h5" component="h5" sx={{ display: 'block' }}>
              Doza de Adrenalină Light
            </Typography>

            <Typography variant="body2" component="p">
              Antrenament, viteză și control - o experiență sportivă în stil Nautic Club DC!
            </Typography>
          </AccordionSummaryWrapper>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Denumire ambarcatiune</TableCell>
                    <TableCell align="center">Capacitate</TableCell>
                    <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>Putere</TableCell>
                    <TableCell align="center">Preț / hr marș</TableCell>
                    <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>Preț / oră staționare</TableCell>
                    <TableCell align="center">Necesită permis</TableCell>
                    <TableCell align="center">Fara skipper</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {preturiData.entry.map((row: PretBarciType) => (
                    <TableRow
                      hover
                      onClick={() => setDialogDetailOpenState(true)}
                      key={row.denumireBarca}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>
                        <img src={row.galleryPhoto} alt={row.denumireBarca} />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.denumireBarca}
                      </TableCell>
                      <TableCell align="center">{row.capacitate}</TableCell>
                      <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>{row.putere}</TableCell>
                      <TableCell align="center">{row.pretMars}</TableCell>
                      <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>{row.pretStationare}</TableCell>
                      <TableCell align="center">{row.necesitaPermis ? '✔ Da' : '❌Nu'}</TableCell>
                      <TableCell align="center">{row.faraSkipper ? '✔ Da' : '❌Nu'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
          <AccordionSummaryWrapper
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h5" component="h5" sx={{ display: 'block' }}>
              Pentru cei experimentati
            </Typography>

            <Typography variant="body2" component="p">
              Ladybug - Cea mai sprintenă din flotă - ideală pentru zâmbete, selfie-uri și senzații tari! Te așteptăm pe lacul Snagov!
              <br />
              Princess Daniela Cristina - Ideală pentru apusuri romantice, ieșiri rafinate și momente memorabile.  Te așteptăm pe lacul Snagov!
            </Typography>
          </AccordionSummaryWrapper>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Denumire ambarcatiune</TableCell>
                    <TableCell align="center">Capacitate</TableCell>
                    <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>Putere</TableCell>
                    <TableCell align="center">Preț / hr marș</TableCell>
                    <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>Preț / oră staționare</TableCell>
                    <TableCell align="center">Necesită permis</TableCell>
                    <TableCell align="center">Fara skipper</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {preturiData.experience.map((row: PretBarciType) => (
                    <TableRow
                      hover
                      onClick={() => setDialogDetailOpenState(true)}
                      key={row.denumireBarca}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>
                        <img src={row.galleryPhoto} alt={row.denumireBarca} />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.denumireBarca}
                      </TableCell>
                      <TableCell align="center">{row.capacitate}</TableCell>
                      <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>{row.putere}</TableCell>
                      <TableCell align="center">{row.pretMars}</TableCell>
                      <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>{row.pretStationare}</TableCell>
                      <TableCell align="center">{row.necesitaPermis ? '✔ Da' : '❌Nu'}</TableCell>
                      <TableCell align="center">{row.faraSkipper ? '✔ Da' : '❌Nu'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
          <AccordionSummaryWrapper
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h5" component="h5" sx={{ display: 'block' }}>
              O experiență premium
            </Typography>

            <Typography variant="body2" component="p">
              Plimbare ca-n filme, cu lux, liniște și experiență premium.
              <br />
              Te așteptăm pe lacul Snagov!
            </Typography>
          </AccordionSummaryWrapper>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Denumire ambarcatiune</TableCell>
                    <TableCell align="center">Capacitate</TableCell>
                    <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>Putere</TableCell>
                    <TableCell align="center">Preț / marș croaziera</TableCell>
                    <TableCell align="center">Preț / marș in viteză </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {preturiData.premium.map((row: PretBarciType) => (
                    <TableRow
                      hover
                      onClick={() => setDialogDetailOpenState(true)}
                      key={row.denumireBarca}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>
                        <img src={row.galleryPhoto} alt={row.denumireBarca} />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.denumireBarca}
                      </TableCell>
                      <TableCell align="center">{row.capacitate}</TableCell>
                      <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>{row.putere}</TableCell>
                      <TableCell align="center">{row.pretMars}</TableCell>
                      <TableCell align="center" sx={{ display: { sm: 'none', md: 'table-cell' } }}>{row.pretStationare}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </Container>

      <Dialog
        open={dialogDetailOpenState}
        onClose={() => handleDetailModalOpenState(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Titlu
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Continut
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDetailModalOpenState(false)} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </TarifeWrapper>
  )
}